import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { Tooltip } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'

const labelStyle = {
    fontSize: '1.2rem',
    textTransform: 'uppercase',
    color: '#9b9b9b',
    fontWeight: '600',
    maxWidth: '11rem',
    width: '100%',
    marginTop: '.1rem',
}
const valueStyle = { fontSize: '1.4rem', fontWeight: '600' }

/**
 * @param {Object} props
 * @param {Array<{ key: string; value?: any }>} [props.items]
 * @param {Object} [props.style]
 */
const InfoTooltip = ({ items = [], style = {} }) => {
    const theme = useTheme()

    if (!items?.length) return null

    const infoMessage = () => (
        <Box padding="1rem" style={{ minWidth: '40rem' }}>
            {items.map(({ key, value }, i) => (
                <Box
                    key={`${key}-${i}`}
                    display="flex"
                    style={{
                        gap: '1rem',
                        ...(i > 0 && { marginTop: '1.5rem' }),
                    }}
                >
                    <Typography variant="label" style={labelStyle}>
                        {key}
                    </Typography>
                    <Typography style={valueStyle}>{value ?? '-'}</Typography>
                </Box>
            ))}
        </Box>
    )

    return (
        <Box sx={{ ml: '0.8rem', ...style }}>
            <Tooltip
                title={infoMessage()}
                color={theme?.palette?.common?.white}
                fontColor={theme?.palette?.common?.black}
                tooltipStyles={{
                    maxWidth: '65rem',
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.1)',
                    width: '100%',
                }}
                arrow={true}
                disableInteractive={false}
            >
                <Box
                    sx={{
                        height: '1.6rem',
                        '&:hover': { '& path': { fill: '#0057A0' } },
                    }}
                >
                    <Icon name="InfoNew" />
                </Box>
            </Tooltip>
        </Box>
    )
}

export default InfoTooltip
